import DeviceOverviewContainer from '~/modules/devices/containers/DeviceOverviewContainer';
import { usePageTitle } from '~components/DashboardWrapper/PageTitle';
import { t } from '~/i18n';

export default function DeviceOverviewPage() {
  usePageTitle(t('menu.dashboard.deviceOverview'));
  return <DeviceOverviewContainer />;
}
